import React, { useEffect, useState, useRef } from 'react';
import { DocumentsServices } from '../../../services';
import { useDocumentPreview } from '../../../utils/useDocumentPreview';
import './style.css';
import { Layout, Table, Space, Button, Modal, Input } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
const { Content } = Layout;

function Indicators() {
  const fileElement = useRef(null);
  const { open: openPreview, modal: previewModal } = useDocumentPreview();

  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [submitError, setSubmitError] = useState(false);

  const [indicators, setIndicators] = useState([]);
  const [showAddLegalReportModal, setShowAddLegalReportModal] = useState(false);
  const [showUpdateLegalReportModal, setShowUpdateLegalReportModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [legalReportId, setLegalReportId] = useState(null);

  async function fetchIndicators() {
    try {
      const response = await DocumentsServices.fetchDocuments('indicators');
      setIndicators(response.data);
    } catch(error) {
      console.log(error);
    }
  }

  function handleShowUpdateLegalReportModal(notice) {
    setLegalReportId(notice.id);
    setTitle(notice.title);
    setSubtitle(notice.subtitle);
    setShowUpdateLegalReportModal(true);
  }

  async function handleDeleteLegalReport(notice) {
    setIsLoading(true);
    try {
      await DocumentsServices.deleteDocument(notice.id);
      await fetchIndicators();
    } catch(error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  const columns = [
    {
      title: 'Título',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Subtítulo',
      dataIndex: 'subtitle',
      key: 'subtitle',
    },
    {
      title: 'Arquivo',
      dataIndex: 'file',
      key: 'file',
      render: (_, record) => (
        <Button
          onClick={() => openPreview(record.filename, record.title)}
        >
          Ver
        </Button>
      )
    },
    {
      title: 'Data de Criação',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: text => text.split('T')[0].split('-').reverse().join('/'),
    },
    {
      title: 'Ações',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => handleShowUpdateLegalReportModal(record)}
          >
            <EditOutlined />
          </Button>
          <Button
            onClick={() => handleDeleteLegalReport(record)}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function fetchIndicators() {
      try {
        const response = await DocumentsServices.fetchDocuments('indicators');
        setIndicators(response.data);
      } catch(error) {
        console.log(error);
      }
    }

    fetchIndicators();
  }, []);

  function handleCloseAddLegalReportModal() {
    setTitle('');
    setSubtitle('');
    setSelectedFile(null);
    setSubmitError(false);
    if (fileElement.current) {
      fileElement.current.value = '';
    }
    setShowAddLegalReportModal(false);
  }

  function handleCloseUpdateLegalReportModal() {
    setTitle('');
    setSubtitle('');
    setSelectedFile(null);
    setShowUpdateLegalReportModal(false);
  }

  async function handleAddLegalReport() {
    if(title.length < 3 || fileElement.current.files.length < 1) {
      return setSubmitError('Os campos devem ser preenchidos corretamente.');
    }
    setSubmitError(false);
    setIsLoading(true);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('subtitle', subtitle);
    formData.append('category', 'indicators');
    formData.append('file', fileElement.current.files[0]);
    try {
      await DocumentsServices.addDocument(formData);
      await fetchIndicators();
      handleCloseAddLegalReportModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  async function handleUpdateLegalReport() {
    const payload = {};
    if(title.length > 2) {
      payload.title = title;
    }
    if(subtitle.length > 0) {
      payload.subtitle = subtitle;
    }
    setSubmitError(false);
    setIsLoading(true);
    try {
      await DocumentsServices.updateDocument(legalReportId, payload);
      await fetchIndicators();
      handleCloseUpdateLegalReportModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  return (
    <Content style={{ margin: '24px 16px 0' }}>
      {previewModal}
      <Modal
        visible={showAddLegalReportModal}
        destroyOnClose
        title="Adicionar Indicador"
        onOk={handleAddLegalReport}
        onCancel={handleCloseAddLegalReportModal}
        footer={[
          <Button key="back" onClick={handleCloseAddLegalReportModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleAddLegalReport}>
            Cadastrar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Título"
          size="large"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Input
          className="login-input"
          placeholder="Subtítulo"
          size="large"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
        <input style={{ marginTop: '20px' }} type="file" ref={fileElement} />
      </Modal>
      <Modal
        visible={showUpdateLegalReportModal}
        destroyOnClose
        title="Atualizar Indicador"
        onOk={handleUpdateLegalReport}
        onCancel={handleCloseUpdateLegalReportModal}
        footer={[
          <Button key="back" onClick={handleCloseUpdateLegalReportModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleUpdateLegalReport}>
            Atualizar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Usuário"
          size="large"
          defaultValue={title || ''}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Input
          className="login-input"
          placeholder="Senha"
          size="large"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
      </Modal>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          Notícias
          <Button className="button-add-indicators" type="primary" onClick={() => {
            setTitle('');
            setSubtitle('');
            setSubmitError(false);
            if (fileElement.current) fileElement.current.value = '';
            setShowAddLegalReportModal(true);
          }}>
            Adicionar Indicador
          </Button>
        </div>
        {indicators.length > 0 && (
          <Table rowKey="id" style={{ marginTop: '40px' }} columns={columns} dataSource={indicators} />
        )}
      </div>
    </Content>
  );
}

export default Indicators;